import React, {
  useEffect, useState, useCallback,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  FormControl, Button, IconButton,
} from '@mui/material';
import { FilterList } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';

import * as actions from '../../../store/actions';

import { DivFormTitle } from './styles';
import Autocomplete from '../../../UI/Autocomplete/Autocomplete';
import { i18n } from '../../../translate/i18n';

const CalendarFilterModal = (props) => {
  const dispatch = useDispatch();

  const page = 1;
  const limit = 30;
  const orderBy = 'name';
  const order = 'asc';

  const [searchTextUser, setSearchTextUser] = useState('');
  const [usersFormated, setUsersFormated] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);

  const [searchTextUserMaintenances, setSearchTextUserMaintenances] = useState('');
  const [selectedUsersMaintenances, setSelectedUsersMaintenances] = useState([]);

  const [searchTextSite, setSearchTextSite] = useState('');
  const [sitesFormated, setSitesFormated] = useState([]);
  const [selectedSites, setSelectedSites] = useState([]);

  const [searchTextEquipment, setSearchTextEquipment] = useState('');
  const [equipmentsFormated, setEquipmentsFormated] = useState([]);
  const [selectedEquipmentModels, setSelectedEquipmentModels] = useState([]);

  const [searchTextEquipmentGroup, setSearchTextEquipmentGroup] = useState('');
  const [equipmentGroupsFormated, setEquipmentGroupsFormated] = useState([]);
  const [selectedEquipmentGroups, setSelectedEquipmentGroups] = useState([]);

  const [selectedFormats, setSelectedFormats] = useState(() => []);
  const [checkActions, setCheckActions] = useState(false);
  const [checkServices, setCheckServices] = useState(false);
  const [checkMaintenances, setCheckMaintenances] = useState(false)
  const [checkFutureServices, setCheckFutureServices] = useState(false);
  const [checkServicesReplicated, setCheckServicesReplicated] = useState(false);

  const [searchTextPlace, setSearchTextPlace] = useState('');
  const [placesFormated, setPlacesFormated] = useState([]);
  const [selectedPlaces, setSelectedPlaces] = useState([]);

	const [searchTextServiceType, setSearchTextServiceType] = useState('');
	const [serviceTypesFormated, setServiceTypesFormated] = useState([]);
	const [selectedServiceTypes, setSelectedServiceTypes] = useState([]);

	const [searchTextFrequency, setSearchTextFrequency] = useState('');
	const [frequenciesFormated, setFrequenciesFormated] = useState([]);
	const [selectedFrequencies, setSelectedFrequencies] = useState([]);

  const [searchTextArea, setSearchTextArea] = useState('');
  const [areasFormated, setAreasFormated] = useState([]);
  const [selectedAreas, setSelectedAreas] = useState([]);

  const [searchTextStatus, setSearchTextStatus] = useState('');
  const [selectedStatus, setSelectedStatus] = useState([]);

  const [searchTextStatusMaintenances, setSearchTextStatusMaintenances] = useState('');
  const [selectedStatusMaintenances, setSelectedStatusMaintenances] = useState([]);

  const [searchTextCompany, setSearchTextCompany] = useState('');
  const [companyFormated, setCompanyFormated] = useState([]);
  const [selectedCompanies, setSelectedCompanies] = useState([]);

  const [status] = useState([{
		value: 'progress',
		label: i18n.t('statusActionModalFilter.progress')
	},
	{
		value: 'overdue',
		label: i18n.t('statusActionModalFilter.overdue')
	},
	{
		value: 'completed',
		label: i18n.t('statusActionModalFilter.completed')
	}]);

  const statusMaintenances = [{
		value: 'scheduled',
		label: i18n.t('maintenancesStatusLabel.title3')
	},
  {
		value: 'pending',
		label: i18n.t('maintenancesStatusLabel.title4')
	},
  {
		value: 'progress',
		label: i18n.t('maintenancesStatusLabel.title')
	},
  {
		value: 'expired',
		label: i18n.t('maintenancesStatusLabel.title6')
	},
  {
		value: 'completed',
		label: i18n.t('maintenancesStatusLabel.title2')
	},
  {
		value: 'overdue',
		label: i18n.t('maintenancesStatusLabel.title5')
	}];

  const fetchUsers = useCallback(
    () => dispatch(actions.fetchUsers(page, limit, searchTextUser, order, orderBy)),
    [searchTextUser],
  );

  const fetchUsersMaintenances = useCallback(
    () => dispatch(actions.fetchUsers(page, limit, searchTextUserMaintenances, order, orderBy)),
    [searchTextUserMaintenances],
  );

  const fetchSites = useCallback(
    () => dispatch(actions.fetchSites(page, limit, searchTextSite, order, orderBy)),
    [searchTextSite],
  );

  const fetchEquipments = useCallback(
    () => dispatch(actions.fetchEquipmentModels(page, limit, searchTextEquipment, order, orderBy)),
    [searchTextEquipment],
  );

  const fetchEquipmentGroups = useCallback(
    () => dispatch(actions.fetchGroups(page, limit, searchTextEquipmentGroup, order, orderBy)),
    [searchTextEquipmentGroup],
  );

  const fetchPlaces = useCallback(
    () => dispatch(actions.fetchPlacesLeafs(selectedSites)),
    [selectedSites]
  );
  
	const fetchServiceTypes = useCallback(
		() => dispatch(actions.fetchServiceTypes(page, limit, searchTextServiceType, order, orderBy)),
		[page, limit, searchTextServiceType, order, orderBy]
	);

	const fetchFrequencies = useCallback(
		() => dispatch(actions.fetchFrequency(page, limit, searchTextFrequency, order, orderBy)),
		[page, limit, searchTextFrequency, order, orderBy]
	);

  const fetchAreas = useCallback(
    () => dispatch(actions.fetchAreas(page, limit, searchTextArea, order, orderBy)),
    [searchTextArea],
  );

  const fetchCompanies = useCallback(
    () => dispatch(actions.fetchCompanies(page, limit, searchTextCompany, order, orderBy)),
    [searchTextCompany],
  );

  const users = useSelector(state => state.users.users);
  const sites = useSelector(state => state.sites.sites);
  const equipmentModels = useSelector(state => state.equipmentModels.equipmentModels);
  const equipmentGroups = useSelector(state => state.groups.groups);
  const places = useSelector(state => state.places.placesLeafs);
	const serviceTypes = useSelector(state => state.serviceTypes.serviceTypes);
	const frequencies = useSelector(state => state.frequency.frequencies);
  const areas = useSelector(state => state.areas.areas);
  const companies = useSelector(state => state.companies.companies);
  const selectedAccess = useSelector(state => state.auth.selectedAccess);

  const filteredSites = useSelector(state => state.sites.selectedSitesPlaces);
  const filteredUsers = useSelector(state => state.calendars.filteredUsers);
  const filteredUsersMaintenances = useSelector(state => state.calendars.filteredUsersMaintenances);
  const filteredEquipmentModels = useSelector(state => state.calendars.filteredEquipmentModels);
  const filteredEquipmentGroups = useSelector(state => state.calendars.filteredEquipmentGroups);
	const filteredServiceTypes = useSelector(state => state.calendars.filteredServiceTypes);
	const filteredFrequencies = useSelector(state => state.calendars.filteredFrequencies);
  const filteredPlaces = useSelector(state => state.calendars.filteredPlaces);
  const filteredModules = useSelector(state => state.calendars.filteredModules);
  const filteredAreas = useSelector(state => state.calendars.filteredAreas);
  const filteredStatus = useSelector(state => state.calendars.filteredStatus);
  const filteredStatusMaintenances = useSelector(state => state.calendars.filteredStatusMaintenances);
  const filteredCompanies = useSelector(state => state.calendars.filteredCompanies);

  const loadingUsers = useSelector(state => state.users.loading);
  const loadingSites = useSelector(state => state.sites.loading);
  const loadingEquipments = useSelector(state => state.equipmentModels.loading);
  const loadingEquipmentGroups = useSelector(state => state.groups.loading);
  const loadingPlaces = useSelector(state => state.places.loading);
	const loadingServiceTypes = useSelector(state => state.serviceTypes.loading);
	const loadingFrequencies = useSelector(state => state.frequency.loading);
  const loadingAreas = useSelector(state => state.areas.loading);
  const loadingCompanies = useSelector(state => state.companies.loading);

  useEffect(() => {
    handleInputChangeSites(filteredSites);
    handleInputChangeUsers(filteredUsers);
    handleInputChangeUsersMaintenances(filteredUsersMaintenances);
    handleInputChangeEquipments(filteredEquipmentModels);
    handleInputChangeEquipmentGroups(filteredEquipmentGroups);
		handleInputChangeServiceTypes(filteredServiceTypes);
		handleInputChangeFrequencies(filteredFrequencies);
    handleInputChangePlaces(filteredPlaces);
    handleInputChangeAreas(filteredAreas);
    handleInputChangeStatus(filteredStatus);
    handleInputChangeStatusMaintenances(filteredStatusMaintenances);
    handleInputChangeCompanies(filteredCompanies);
    initModules(filteredModules);
  }, []);

  useEffect(() => {
    fetchUsers(limit, searchTextUser, order, orderBy);
  }, [searchTextUser]);

  useEffect(() => {
    fetchUsersMaintenances(limit, searchTextUserMaintenances, order, orderBy);
  }, [searchTextUserMaintenances]);

  useEffect(() => {
    fetchSites(limit, searchTextSite, order, orderBy);
  }, [searchTextSite]);

  useEffect(() => {
    fetchEquipments(limit, searchTextEquipment, order, orderBy);
  }, [searchTextEquipment]);

  useEffect(() => {
    fetchEquipmentGroups(limit, searchTextEquipmentGroup, order, orderBy);
  }, [searchTextEquipmentGroup]);

  useEffect(() => {
    fetchPlaces(selectedSites);
  }, [selectedSites]);

  useEffect(() => {
    setSelectedFormats(filteredModules);
  }, [filteredModules]);

	useEffect(() => {
		fetchServiceTypes(limit, searchTextServiceType, order, orderBy);
	}, [searchTextServiceType]);

	useEffect(() => {
		fetchFrequencies(limit, searchTextFrequency, order, orderBy);
	}, [searchTextFrequency]);

  useEffect(() => {
    fetchAreas(limit, searchTextArea, order, orderBy);
  }, [searchTextArea]);

  useEffect(() => {
    if (selectedAccess.role !== 'contractor') {
      fetchCompanies(limit, searchTextCompany, order, orderBy);
    }
  }, [searchTextCompany]);

  useEffect(() => {
    const dataFromRedux = users;
    const returnArray = [];
    dataFromRedux.rows.map(dt => returnArray.push({ value: dt._id, label: dt.name }));
    setUsersFormated(returnArray);
  }, [users]);

  useEffect(() => {
    const dataFromRedux = sites;
    const returnArray = [];
    dataFromRedux.rows.map(dt => returnArray.push({ value: dt._id, label: dt.name, ...dt }));
    setSitesFormated(returnArray);
  }, [sites]);

  useEffect(() => {
    const dataFromRedux = equipmentModels;
    const returnArray = [];
    dataFromRedux.rows.map(dt => returnArray.push({ value: dt._id, label: dt.name }));
    setEquipmentsFormated(returnArray);
  }, [equipmentModels]);

  useEffect(() => {
    const dataFromRedux = equipmentGroups;
    const returnArray = [];
    dataFromRedux.rows.map(dt => returnArray.push({ value: dt._id, label: dt.name }));
    setEquipmentGroupsFormated(returnArray);
  }, [equipmentGroups]);

  useEffect(() => {
    const dataFromRedux = places
    const returnArray = [];
    dataFromRedux.rows.map(dt => returnArray.push({ value: dt._id, label: `${dt.name} - (${dt.path})` }))
    setPlacesFormated(returnArray)
  }, [places]);

	useEffect(() => {
		const dataFromRedux = serviceTypes
		let returnArray = []
		dataFromRedux.rows.map(dt => returnArray.push({ value: dt._id, label: dt.name }))
		setServiceTypesFormated(returnArray)
	}, [serviceTypes])

	useEffect(() => {
		const dataFromRedux = frequencies
		let returnArray = []
		dataFromRedux.rows.map(dt => returnArray.push({ value: dt._id, label: dt.name }))
		setFrequenciesFormated(returnArray)
	}, [frequencies])

  useEffect(() => {
    const dataFromRedux = areas;
    const returnArray = [];
    dataFromRedux.rows.map(dt => returnArray.push({ value: dt._id, label: dt.name }));
    setAreasFormated(returnArray);
  }, [areas]);

  useEffect(() => {
    const dataFromRedux = companies;
    const returnArray = [];
    dataFromRedux.rows.map(dt => returnArray.push({ value: dt._id, label: dt.name }));
    setCompanyFormated(returnArray);
  }, [companies]);

  const initModules = (modules) => {
    setCheckActions(modules.indexOf('actions') !== -1);
    setCheckServices(modules.indexOf('services') !== -1);
    setCheckMaintenances(modules.indexOf('maintenances') !== -1);
    setCheckFutureServices(modules.indexOf('future services') !== -1);
    setCheckServicesReplicated(modules.indexOf('servicesReplicated') !== -1);
  };

  const handleInputChangeSelectorUsers = (text) => {
    setSearchTextUser(text);
  };

  const handleInputChangeSelectorUsersMaintenances = (text) => {
    setSearchTextUserMaintenances(text);
  };

  const handleInputChangeSelectorSites = (text) => {
    setSearchTextSite(text);
  };

  const handleInputChangeSelectorEquipments = (text) => {
    setSearchTextEquipment(text);
  };

	const handleInputChangeSelectorServiceTypes = (text) => {
		setSearchTextServiceType(text);
	}

	const handleInputChangeSelectorFrequencies = (text) => {
		setSearchTextFrequency(text);
	}

  const handleInputChangeSelectorEquipmentGroup = (text) => {
    setSearchTextEquipmentGroup(text);
  };

  const handleInputChangeSelectorPlace = (text) => {
    setSearchTextPlace(text);
  };

  const handleInputChangeSelectorAreas = (text) => {
    setSearchTextArea(text);
  };

  const handleInputChangeSelectorStatus = (text) => {
    setSearchTextStatus(text);
  };

  const handleInputChangeSelectorStatusMaintenances = (text) => {
    setSearchTextStatusMaintenances(text);
  };

  const handleInputChangeSelectorCompanies = (text) => {
    setSearchTextCompany(text);
  };

  const handleInputChangeUsers = (selected) => {
    setSelectedUsers(selected);
  };

  const handleInputChangeUsersMaintenances = (selected) => {
    setSelectedUsersMaintenances(selected);
  };

  const handleInputChangeSites = (selected) => {
    if (selected) {
      const dataFromRedux = selected;
      const returnArray = [];
      dataFromRedux.map(dt => returnArray.push({ value: dt._id, label: dt.name, ...dt }));
      setSelectedSites(returnArray);
    } else {
      setSelectedSites([]);
    }
  };

  const handleInputChangeEquipments = (selected) => {
    setSelectedEquipmentModels(selected);
  };

  const handleInputChangeEquipmentGroups = (selected) => {
    setSelectedEquipmentGroups(selected);
  };

  const handleInputChangePlaces = (selected) => {
    setSelectedPlaces(selected);
  };

	const handleInputChangeServiceTypes = selected => {
		setSelectedServiceTypes(selected);
	}

	const handleInputChangeFrequencies = selected => {
		setSelectedFrequencies(selected);
	}

  const handleInputChangeAreas = (selected) => {
    setSelectedAreas(selected);
  };

  const handleInputChangeStatus = (selected) => {
    setSelectedStatus(selected);
  };

  const handleInputChangeStatusMaintenances = (selected) => {
    setSelectedStatusMaintenances(selected);
  };

  const handleInputChangeCompanies = (selected) => {
    setSelectedCompanies(selected);
  };

  const selectedFormatsToDispach = () => {
    const dt = [];
    if (checkActions) dt.push('actions');
    if (checkServices) dt.push('services');
    if (checkMaintenances) dt.push('maintenances');
    if (checkFutureServices) dt.push('future services');
    if (checkServicesReplicated) dt.push('servicesReplicated');
    return dt;
  };

  const handleClickFilter = () => {
    dispatch(actions.setSitePlaces(selectedSites));
    dispatch(actions.filterCalendarUsers(selectedUsers));
    dispatch(actions.filterCalendarUsersMaintenances(selectedUsersMaintenances));
    dispatch(actions.filterCalendarEquipmentModels(selectedEquipmentModels));
    dispatch(actions.filterCalendarEquipmentGroups(selectedEquipmentGroups));
		dispatch(actions.filterCalendarServiceTypes(selectedServiceTypes));
		dispatch(actions.filterCalendarFrequencies(selectedFrequencies));
    dispatch(actions.filterCalendarPlaces(selectedPlaces));
    dispatch(actions.filterCalendarAreas(selectedAreas));
    dispatch(actions.filterCalendarStatus(selectedStatus));
    dispatch(actions.filterCalendarStatusMaintenances(selectedStatusMaintenances));
    dispatch(actions.filterCalendarCompanies(selectedCompanies));
    dispatch(actions.filterCalendarModules(selectedFormatsToDispach()));
    props.closeModal();
  };

  const handleClickClearFilters = () => {
    setSelectedUsers([]);
    setSelectedUsersMaintenances([]);
    setSelectedEquipmentModels([]);
    setSelectedEquipmentGroups([]);
		setSelectedServiceTypes([])
		setSelectedFrequencies([])
    setSelectedPlaces([]);
    setSelectedFormats([]);
    setSelectedAreas([]);
    setSelectedStatus([]);
    setSelectedStatusMaintenances([]);
    setSelectedCompanies([]);
  };

  return (
    <div style={styles.container}>
      <DivFormTitle style={styles.headerContainer}>
        <div style={{ display: 'flex', alignItems: 'center', fontSize: '1.25rem' }}>
          <FilterList style={{ marginRight: '1rem' }} />
          {i18n.t('filterListModal.text')}
          {((selectedUsers && selectedUsers.length > 0)
          || (selectedUsersMaintenances && selectedUsersMaintenances.length > 0)
					|| (selectedEquipmentModels && selectedEquipmentModels.length > 0)
          || (selectedEquipmentGroups && selectedEquipmentGroups.length > 0)
          || (selectedFormats && selectedFormats.length !== 3)
          || (selectedServiceTypes && selectedServiceTypes.length > 0)
          || (selectedFrequencies && selectedFrequencies.length > 0)
          || (selectedAreas && selectedAreas.length > 0)
          || (selectedStatus && selectedStatus.length > 0)
          || (selectedStatusMaintenances && selectedStatusMaintenances.length > 0)
          || (selectedCompanies && selectedCompanies.length > 0))
					&& <div style={styles.clearFilter} onClick={handleClickClearFilters}>{i18n.t('filterListModal.clear')}</div>}
        </div>
        <IconButton onClick={props.closeModal} color="inherit" size="large">
          <CloseIcon />
        </IconButton>
      </DivFormTitle>
      <div style={styles.bodyContainer}>
        <FormControl variant="standard" fullWidth margin="normal">
          <Autocomplete
            loading={loadingSites}
            label={i18n.t('autocompleteCalendarFilter.sites')}
            data={sitesFormated}
            onSelectValue={handleInputChangeSites}
            valueSelected={selectedSites}
            newSearchText={handleInputChangeSelectorSites}
            isMulti
          />
        </FormControl>
        <FormControl variant="standard" fullWidth margin="normal">
          <Autocomplete
            loading={loadingUsers}
            label={i18n.t('autocompleteCalendarFilter.users')}
            data={usersFormated}
            onSelectValue={handleInputChangeUsers}
            valueSelected={selectedUsers}
            newSearchText={handleInputChangeSelectorUsers}
            isMulti
          />
        </FormControl>
        <FormControl variant="standard" fullWidth margin="normal">
          <Autocomplete
            loading={loadingEquipments}
            label={i18n.t('autocompleteCalendarFilter.equipments')}
            data={equipmentsFormated}
            onSelectValue={handleInputChangeEquipments}
            valueSelected={selectedEquipmentModels}
            newSearchText={handleInputChangeSelectorEquipments}
            isMulti
          />
        </FormControl>
        <FormControl variant="standard" fullWidth margin="normal">
          <Autocomplete
            loading={loadingEquipmentGroups}
            label={i18n.t('autocompleteCalendarFilter.equipmentGroups')}
            data={equipmentGroupsFormated}
            onSelectValue={handleInputChangeEquipmentGroups}
            valueSelected={selectedEquipmentGroups}
            newSearchText={handleInputChangeSelectorEquipmentGroup}
            isMulti
          />
        </FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						loading={loadingServiceTypes}
						label={i18n.t('autocompleteCalendarFilter.serviceTypes')}
						data={serviceTypesFormated}
						onSelectValue={handleInputChangeServiceTypes}
						valueSelected={selectedServiceTypes}
						newSearchText={handleInputChangeSelectorServiceTypes}
						isMulti
					/>
				</FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						loading={loadingFrequencies}
						label={i18n.t('autocompleteCalendarFilter.frequencies')}
						data={frequenciesFormated}
						onSelectValue={handleInputChangeFrequencies}
						valueSelected={selectedFrequencies}
						newSearchText={handleInputChangeSelectorFrequencies}
						isMulti
					/>
				</FormControl>
        <FormControl variant="standard" fullWidth margin="normal">
          <Autocomplete
            loading={loadingPlaces}
            label="Local"
            data={placesFormated}
            onSelectValue={handleInputChangePlaces}
            valueSelected={selectedPlaces}
            newSearchText={handleInputChangeSelectorPlace}
            isMulti
          />
        </FormControl>
        <FormControl variant="standard" fullWidth margin="normal">
          <Autocomplete
            loading={loadingAreas}
            label={i18n.t('autocompleteCalendarFilter.areas')}
            data={areasFormated}
            onSelectValue={handleInputChangeAreas}
            valueSelected={selectedAreas}
            newSearchText={handleInputChangeSelectorAreas}
            isMulti
          />
        </FormControl>
        <FormControl variant="standard" fullWidth margin="normal">
          <Autocomplete
            //loading={loadingStatus}
            label={i18n.t('autocompleteActionModalFilter.status')}
            data={status}
            onSelectValue={handleInputChangeStatus}
            valueSelected={selectedStatus}
            newSearchText={handleInputChangeSelectorStatus}
            isMulti
          />
        </FormControl>

        <FormControl variant="standard" fullWidth margin="normal">
          <Autocomplete
            loading={loadingUsers}
            label={i18n.t('autocompleteActionModalFilter.maintenanceCreatedBy')}
            data={usersFormated}
            onSelectValue={handleInputChangeUsersMaintenances}
            valueSelected={selectedUsersMaintenances}
            newSearchText={handleInputChangeSelectorUsersMaintenances}
            isMulti
          />
        </FormControl>

        <FormControl variant="standard" fullWidth margin="normal">
          <Autocomplete
            label={i18n.t('autocompleteActionModalFilter.statusMaintenances')}
            data={statusMaintenances}
            onSelectValue={handleInputChangeStatusMaintenances}
            valueSelected={selectedStatusMaintenances}
            newSearchText={handleInputChangeSelectorStatusMaintenances}
            isMulti
          />
        </FormControl>

        {selectedAccess.role !== 'contractor' &&
          <FormControl variant="standard" fullWidth margin="normal">
            <Autocomplete
              loading={loadingCompanies}
              label={i18n.t('autocompleteCalendarFilter.company')}
              data={companyFormated}
              onSelectValue={handleInputChangeCompanies}
              valueSelected={selectedCompanies}
              newSearchText={handleInputChangeSelectorCompanies}
              isMulti
            />
          </FormControl>
        }
        <div style={styles.toggleButtonLabel}>
            {i18n.t('divCalendarModalFilter.label')}
        </div>
        <div style={styles.toggleButtonContainer}>
          <FormControlLabel
            control={<Switch checked={checkActions} onChange={e => setCheckActions(e.target.checked)} />}
            label={i18n.t('formControlLabelCalendar.checkActions')}
          />
          <FormControlLabel
            control={<Switch checked={checkServices} onChange={e => setCheckServices(e.target.checked)} />}
            label={i18n.t('formControlLabelCalendar.checkServices')}
          />
          <FormControlLabel
            control={<Switch checked={checkServicesReplicated} onChange={e => setCheckServicesReplicated(e.target.checked)} />}
            label={i18n.t('formControlLabelCalendar.checkServicesReplicated')}
          />
          <FormControlLabel
            control={<Switch checked={checkMaintenances} onChange={e => setCheckMaintenances(e.target.checked)} />}
            label={i18n.t('formControlLabelCalendar.checkMaintenances')}
          />
          {/* <FormControlLabel
            control={<Switch checked={checkFutureServices} onChange={e => setCheckFutureServices(e.target.checked)} />}
            label={i18n.t('formControlLabelCalendar.checkFutureServices')}
          /> */}
        </div>
      </div>
      <div style={styles.footerContainer}>
        <div
          onClick={props.closeModal}
          style={styles.buttonCancel}
        >
          {i18n.t('divCalendarModalFilter.closeModal')}
        </div>
        <Button
          variant="contained"
          color="primary"
          onClick={handleClickFilter}
          style={styles.button}
        >
          {i18n.t('divCalendarModalFilter.done')}
        </Button>
      </div>
    </div>
  );
};

const styles = {
  container: {
    width: '40rem',
    height: '100%',
  },
  headerContainer: {
    height: '5rem',
    padding: '0 1rem 0 2rem',
    backgroundColor: 'green',
    color: '#fff',
  },
  bodyContainer: {
    height: 'calc(100% - 10rem)',
    padding: '1rem 2rem',
    overflowY: 'auto',
    borderTop: '1px solid #ccc',
    borderBottom: '1px solid #ccc',
  },
  chip: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#C5D1E3',
    margin: '0.5rem 0',
    borderRadius: 10,
    padding: '0.3rem 1rem',
    justifyContent: 'space-between',
  },
  footerContainer: {
    height: '5rem',
    padding: '0 2rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  button: {
    flex: 1,
    backgroundColor: 'green',
    borderRadius: '2rem',
    padding: '0.5rem 1.5rem',
    // width: '100%',
  },
  buttonCancel: {
    flex: 1,
    cursor: 'pointer',
    color: 'grey',
    alignItems: 'center',
    textAlign: 'center',
  },
  clearFilter: {
    fontSize: '1rem',
    marginLeft: '2rem',
    color: '#fff',
    cursor: 'pointer',
    textDecoration: 'underline',
  },
  toggleButtonLabel: {
    marginTop: 10,
    fontSize: '0.8rem',
    color: 'rgba(0, 0, 0, 0.54)',
  },
  toggleButtonContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
};

export default CalendarFilterModal;
